import { useUserMeQuery } from 'store/slices/user/apis/user';

import ProfileView from './ProfileView';

import type { ReactElement } from 'react';

function Profile(): ReactElement {
  const { data, isLoading } = useUserMeQuery();
  const companyLanguages = data?.data?.company?.localization?.languages || [];

  return (
    <ProfileView companyLanguages={companyLanguages} isLoading={isLoading} />
  );
}

export default Profile;
